import { useEffect, useMemo, useState } from 'react';
import { fetchCitiesOfCountryCached } from '../organizationsBulkAutofill';

/** Города выбранной страны в виде опций { value, label } (с кэшем по стране). */
export default function useCitiesOfCountry(countryId) {
  const [cities, setCities] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    let isCancelled = false;

    if (!countryId) {
      setCities([]);
      setLoading(false);
      return undefined;
    }

    setLoading(true);
    fetchCitiesOfCountryCached(countryId)
      .then((list) => { if (!isCancelled) setCities(list); })
      .catch(() => { if (!isCancelled) setCities([]); })
      .finally(() => { if (!isCancelled) setLoading(false); });

    return () => { isCancelled = true; };
  }, [countryId]);

  const options = useMemo(() => cities
    .map((city) => ({ value: city._id, label: city.name }))
    .sort((a, b) => a.label.localeCompare(b.label, 'ru')), [cities]);

  return { cityOptions: options, citiesLoading: loading };
}
